/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Fragment } from '@wordpress/element';
import {
	__experimentalDivider as Divider,
	__experimentalUnitControl as UnitControl,
	__experimentalNumberControl as NumberControl,
	// __experimentalFontFamilyControl as FontFamilyControl,
	TabPanel,
	ToggleControl,
} from '@wordpress/components';
import { addFilter } from '@wordpress/hooks';
import { __experimentalFontFamilyControl as FontFamilyControl, useSetting } from '@wordpress/block-editor';

/**
 * External dependencies
 */
import { assign, has, isEmpty } from 'lodash';

/**
 * Inner dependencies.
 */
import {
	ColorControl,
	GradientColorControl,
} from '../../../extensions/controls/color-options';
import Accordion from '../../../components/Accordion';
import blockInfo from '../constants';
const { hookPrefix } = blockInfo;

addFilter(
	`gutenify-block-${ hookPrefix }-options-tab-style`,
	`Gutenify/Block/${ hookPrefix }/InspectorControls/BasicControls/tabs/style`,
	( content, props ) => {
		const { attributes, setAttributes } = props;
		const { gap, blockAdvanceOptions } = attributes;
		const { header, content: contentStyle, border } = blockAdvanceOptions;
		// const blockLevelFontFamilies = useSetting( 'typography.fontFamilies' );
		// console.log( blockLevelFontFamilies );
		console.log( border );
		return [
			...content,
			<Fragment key={ `gutenify-block-${ hookPrefix }-options-tab-content-basic` }>
				{ /* <FontFamilyControl
					// fontFamilies={ blockLevelFontFamilies }
					value={ 'fontFamily' }
					// onChange={ () => {} }
				/> */ }
				<Accordion tabs={ [
					{
						name: 'faq-style',
						initialOpen: true,
						label: () => {
							return __( 'Faq Style' );
						},
						cb: () => {
							return <>
								<UnitControl
									label={ __( 'Gap' ) }
									type="number"
									min={ 0 }
									max={ 100 }
									step={ 1 }
									value={ gap }
									onChange={ ( val ) => {
										const data = {
											gap: val,
										};
										setAttributes( data );
									} } />
							</>;
						},
					},
				] } />
				<Accordion tabs={ [
					{
						name: 'button',
						initialOpen: true,
						label: () => {
							return __( 'Header Style' );
						},
						cb: () => {
							return <>
								<TabPanel
									className="gutenify-editor-tab-panel gutenify-editor-tab-ovel"
									activeClass="active-tab"
									tabs={ [
										{
											name: 'normal',
											title: __( 'Normal' ),
											className: 'gutenify-color-normal-tab',
										},
										{
											name: 'hover',
											title: __( 'Hover' ),
											className: 'gutenify-color-hover-tab',
										},
									] }
								>
									{ ( tabInner ) => {
										return (
											<>
												{ 'normal' === tabInner.name && (
													<>
														<ColorControl
															label={ __( 'Color' ) }
															onChange={ ( color ) => {
																const data = {
																	blockAdvanceOptions: {
																		...assign( blockAdvanceOptions, {
																			header: {
																				...header,
																				textColor: color,
																			},
																		} ),
																	},
																};

																setAttributes( data );
															} }
															value={ header?.textColor }
														/>
														<ToggleControl label={ __( 'Transparent Background' ) } checked={ has( header, 'backgroundColor' ) && 'transparent' === header.backgroundColor }
															onChange={ () => {
																const val = {
																	backgroundColor: 'transparent',
																	backgroundGradient: '',
																};
																if ( 'transparent' === header.backgroundColor ) {
																	val.backgroundColor = '';
																}
																const data = {
																	blockAdvanceOptions: {
																		...assign( blockAdvanceOptions, {
																			header: {
																				...header,
																				...val,
																			},
																		} ),
																	},
																};
																setAttributes( data );
															} } />
														{ ( ! has( header, 'backgroundColor' ) || 'transparent' !== header.backgroundColor ) && <GradientColorControl
															label={ __( 'Background Color' ) }
															colorValue={ header?.backgroundColor }
															gradientValue={ header?.backgroundGradient }
															onChange={ ( val ) => {
																const data = {
																	blockAdvanceOptions: {
																		...assign( blockAdvanceOptions, {
																			header: {
																				...header,
																				...val,
																			},
																		} ),
																	},
																};
																setAttributes( data );
															} }
														/> }
													</>
												) }
												{ 'hover' === tabInner.name && (
													<>
														<ColorControl
															label={ __( 'Color' ) }
															onChange={ ( color ) => {
																const data = {
																	blockAdvanceOptions: {
																		...assign( blockAdvanceOptions, {
																			header: {
																				...header,
																				hoverTextColor: color,
																			},
																		} ),
																	},
																};
																setAttributes( data );
															} }
															value={ header?.hoverTextColor }
														/>
														<ToggleControl label={ __( 'Transparent Background' ) } checked={ has( header, 'hoverBackgroundColor' ) && 'transparent' === header.hoverBackgroundColor }
															onChange={ () => {
																const val = {
																	hoverBackgroundColor: 'transparent',
																	hoverBackgroundGradient: '',
																};
																if ( 'transparent' === header.hoverBackgroundColor ) {
																	val.hoverBackgroundColor = '';
																}
																const data = {
																	blockAdvanceOptions: {
																		...assign( blockAdvanceOptions, {
																			header: {
																				...header,
																				...val,
																			},
																		} ),
																	},
																};
																setAttributes( data );
																// updateBlockStyle( data, props );
															} } />
														{ ( ! has( header, 'hoverBackgroundColor' ) || 'transparent' !== header.hoverBackgroundColor ) && <GradientColorControl
															label={ __( 'Background Color' ) }
															colorValue={ header?.hoverBackgroundColor }
															gradientValue={
																header?.hoverBackgroundGradient
															}
															onChange={ ( value ) => {
																const val = {
																	hoverBackgroundColor: value.backgroundColor,
																	hoverBackgroundGradient: value.backgroundGradient,
																};
																const data = {
																	blockAdvanceOptions: {
																		...assign( blockAdvanceOptions, {
																			header: {
																				...header,
																				...val,
																			},
																		} ),
																	},
																};
																setAttributes( data );
															} }
														/> }
													</>
												) }
												<Divider />
											</>
										);
									} }
								</TabPanel>
							</>;
						},
					},
				] } />
				<Accordion tabs={ [
					{
						name: 'button',
						initialOpen: true,
						label: () => {
							return __( 'Content Style' );
						},
						cb: () => {
							return <>

								<ColorControl
									label={ __( 'Color' ) }
									onChange={ ( color ) => {
										const data = {
											blockAdvanceOptions: {
												...assign( blockAdvanceOptions, {
													content: {
														...contentStyle,
														textColor: color,
													},
												} ),
											},
										};

										setAttributes( data );
									} }
									value={ contentStyle?.textColor }
								/>
								<ToggleControl label={ __( 'Transparent Background' ) } checked={ has( contentStyle, 'backgroundColor' ) && 'transparent' === contentStyle.backgroundColor }
									onChange={ () => {
										const val = {
											backgroundColor: 'transparent',
											backgroundGradient: '',
										};
										if ( 'transparent' === contentStyle.backgroundColor ) {
											val.backgroundColor = '';
										}
										const data = {
											blockAdvanceOptions: {
												...assign( blockAdvanceOptions, {
													content: {
														...contentStyle,
														...val,
													},
												} ),
											},
										};
										setAttributes( data );
									} } />
								{ ( ! has( contentStyle, 'backgroundColor' ) || 'transparent' !== contentStyle.backgroundColor ) && <GradientColorControl
									label={ __( 'Background Color' ) }
									colorValue={ contentStyle?.backgroundColor }
									gradientValue={ contentStyle?.backgroundGradient }
									onChange={ ( val ) => {
										const data = {
											blockAdvanceOptions: {
												...assign( blockAdvanceOptions, {
													content: {
														...contentStyle,
														...val,
													},
												} ),
											},
										};
										setAttributes( data );
									} }
								/> }
							</>;
						},
					},
				] } />
				<Accordion tabs={ [
					{
						name: 'button',
						initialOpen: true,
						label: () => {
							return __( 'Border Style' );
						},
						cb: () => {
							return <>
								<ColorControl
									label={ __( 'Color' ) }
									onChange={ ( color ) => {
										const data = {
											blockAdvanceOptions: {
												...assign( blockAdvanceOptions, {
													border: {
														...border,
														color,
													},
												} ),
											},
										};

										setAttributes( data );
									} }
									value={ border?.color }
								/>
								<NumberControl
									label={ __( 'Width' ) }
									value={ border?.width }
									onChange={ ( width ) => {
										const data = {
											blockAdvanceOptions: {
												...assign( blockAdvanceOptions, {
													border: {
														...border,
														width,
													},
												} ),
											},
										};
										setAttributes( data );
									} }
									min={ 0 }
									max={ 300 }
								/>

								<UnitControl
									label={ __( 'Radius' ) }
									value={ border?.radius }
									onChange={ ( radius ) => {
										const data = {
											blockAdvanceOptions: {
												...assign( blockAdvanceOptions, {
													border: {
														...border,
														radius,
													},
												} ),
											},
										};
										setAttributes( data );
										// updateBlockStyle( data, props );
									} }
									min={ 0 }
									max={ 300 }
									// withInputField={ true }
								/>
							</>;
						},
					},
				] } />
			</Fragment>,
		];
	}
);

